import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import ReclassificationScriptureView from './ReclassificationScriptureView';
import { useReclassificationModal } from '../context/ReclassificationModalContext';
import ReclassificationDataView from './ReclassificationDataView';

const ReclassificationModalBody: FC = () => {
  const { data } = useReclassificationModal();

  return (
    <Modal.Body style={data.scriptureView ? {} : { minHeight: '709px' }}>
      <div className="nk-modal">
        {data.scriptureView ? (
          <ReclassificationScriptureView />
        ) : (
          <ReclassificationDataView />
        )}
      </div>
    </Modal.Body>
  );
};

export default ReclassificationModalBody;
